//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { DaySelectionUpdateItem } from './DaySelectionUpdateItem';
import { CalendarColorMode, CalendarDragAndDropMode, CalendarResourceMode } from './Enums';

export class TeacherCalendarPreferencesUpdateItem extends ItemBase {
    ColorMode?: CalendarColorMode;
    DefaultEventVisibilityIsPublic?: boolean;
    DragAndDropMode?: CalendarDragAndDropMode;
    ResourceMode?: CalendarResourceMode;     // OBSOLETE - Use only for compatibility
    ShowBirthdays?: boolean;
    ShowEventCategoryName?: boolean;
    ShowEventPrice?: boolean;
    ShowOnlyMyOwnEvents?: boolean;
    ShowOpenSlotCount?: boolean;
    ShowRepertoirePerformances?: boolean;
    StartingHourForDayOrWeekView?: number;
    VisibleDays?: DaySelectionUpdateItem | null;

    constructor(initializer?: Partial<TeacherCalendarPreferencesUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherCalendarPreferencesUpdateItem";
}
